var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M15.54 16.54a1 1 0 0 1-.711-1.7 4.02 4.02 0 0 0 0-5.674 1 1 0 0 1 1.422-1.406 6.02 6.02 0 0 1 0 8.486 1 1 0 0 1-.711.294m-6.377-.289a1 1 0 0 0 .008-1.414 4.02 4.02 0 0 1 0-5.674 1 1 0 1 0-1.422-1.406 6.02 6.02 0 0 0 0 8.486 1 1 0 0 0 1.414.008m10.269 2.42a9.95 9.95 0 0 0 0-13.342 1 1 0 1 0-1.483 1.342 7.95 7.95 0 0 1 0 10.658 1 1 0 0 0 1.483 1.342m-13.452.07a1 1 0 0 0 .071-1.412 7.95 7.95 0 0 1 0-10.658 1 1 0 1 0-1.483-1.342 9.95 9.95 0 0 0 0 13.342 1 1 0 0 0 1.412.07M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
})));
export default SvgLive;